<div class="card">
  <h2>Recuperar contraseña</h2>

  <form [formGroup]="form">

    <!-- PASO 1 -->
    <div *ngIf="!usuarioValido">
      <p>Ingresa tu usuario o correo</p>

      <input 
        type="text"
        placeholder="Usuario o correo"
        formControlName="usuario"
      >

      <button type="button" (click)="enviar()" [disabled]="form.get('usuario')?.invalid">
        Validar usuario
      </button>
    </div>

    <!-- PASO 2 -->
    <div *ngIf="usuarioValido">
      <p>Ingresa tu nueva contraseña</p>

      <input 
        type="password"
        placeholder="Nueva contraseña"
        formControlName="password"
      >

      <button type="button" (click)="cambiarPassword()" [disabled]="!form.get('password')?.value">
        Cambiar contraseña
      </button>
    </div>

  </form>
</div>